import { render, staticRenderFns } from "./ProductionBrain.vue?vue&type=template&id=1380f9eb&scoped=true"
import script from "./ProductionBrain.vue?vue&type=script&lang=js"
export * from "./ProductionBrain.vue?vue&type=script&lang=js"
import style0 from "./ProductionBrain.vue?vue&type=style&index=0&id=1380f9eb&prod&lang=scss&scoped=true"
import style1 from "./ProductionBrain.vue?vue&type=style&index=1&id=1380f9eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1380f9eb",
  null
  
)

export default component.exports